var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.3164L12.9005 18.7645C13.0394 18.8447 13.1851 18.9026 13.3333 18.9394V33.3846L0.920065 26.0385C0.349784 25.701 0 25.0875 0 24.4248V11.3164ZM30 11.1184V24.4248C30 25.0875 29.6502 25.701 29.0799 26.0385L16.6667 33.3846V18.8129C16.6969 18.7978 16.7269 18.7816 16.7566 18.7645L30 11.1184Z",
    fill: "#FEC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.405273 7.70142C0.562849 7.50244 0.761736 7.33426 0.993616 7.21076L14.1186 0.2201C14.6696 -0.0733665 15.3305 -0.0733665 15.8815 0.2201L29.0065 7.21076C29.1852 7.30596 29.3444 7.42771 29.4801 7.56966L15.0899 15.8778C14.9953 15.9325 14.9081 15.995 14.8286 16.064C14.7491 15.995 14.6618 15.9325 14.5672 15.8778L0.405273 7.70142Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingMachines);
export default __webpack_public_path__ + "static/media/Working Machines.6b7c4f9f86b0f05ace81587454988724.svg";
export { ForwardRef as ReactComponent };